import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
} from '@mui/material';
import { Buffer } from 'buffer';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { previewToolConst } from '../../constants/previewTool';

// type macroTuple = [string, string];

// TODO:
// - add support for additional custom macros
// - add HTML validation linter
// - add sharing functionality (base64 encode and decode from query params)

function PreviewTool() {
  const [error, setError] = useState<string>('');
  const [searchParams] = useSearchParams();
  const [htmlContent, setHtmlContent] = useState<string>(
    decodeURIComponent(Buffer.from(searchParams.get('previewHtml') || '', 'base64').toString('utf-8'))
  );
  // url macro
  const [urlMacro, setUrlMacro] = useState<string>('https://www.inmarket.com');
  const [urlMacroError] = useState<string>('');
  // additional macros tuples array
  // const [additionalMacros, setAdditionalMacros] = useState<macroTuple[]>([]);

  const handlePreview = async (service?: string): Promise<void> => {
    setError('');

    let localHtml = htmlContent;

    // Do nothing if no HTML is entered
    if (!localHtml || localHtml === '') {
      setError("Nothing entered into the 'HTML' field!");
      return;
    }

    // Apply URL macro replacement
    if (urlMacro !== '') {
      localHtml = localHtml.replace('%{URL0}', urlMacro);
    }

    // Validate HTML
    const doc = new DOMParser().parseFromString(localHtml, 'text/html');
    if (doc.getElementsByTagName('parsererror').length > 0) {
      setError('Invalid HTML content! - Open the developer console for more details.');
      return;
    }

    if (service === 'testatag') {
      // Open in TestaTag
      const base64String = Buffer.from(localHtml).toString('base64');
      window.open(`https://test-a-tag.com/#v2,1,${base64String}`, '_blank');
      return;
    }

    // Default: Encode for legacy external preview tool
    const encodedHtml = encodeURIComponent(localHtml);
    const base64String = Buffer.from(encodedHtml).toString('base64');
    window.open(`${previewToolConst.simplePreviewHostname}?p=d&h=${base64String}`, '_blank');
  };

  return (
    <Box p={2}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}>
        <Stack direction="row" alignItems="center">
          <Typography variant="h5">Ad Preview Tool</Typography>
        </Stack>
      </Box>
      <Grid container>
        <Grid item lg={12} xl={6} sx={{ p: 2, mt: 2, backgroundColor: 'white', width: '100%', borderRadius: '4px' }}>
          <Typography variant="body2">{previewToolConst.macroDescription}</Typography>
          {/* Macros */}
          <FormControl sx={{ my: 1, width: '15%' }}>
            <OutlinedInput
              onChange={(e) => setUrlMacro(e.target.value)}
              error={Boolean(urlMacroError)}
              name="urlMacro"
              id="urlMacro"
              value="%{URL0}"
              sx={{ borderRadius: '4px 0 0 4px' }}
              disabled
            />
          </FormControl>
          <FormControl sx={{ my: 1, minWidth: '60%' }}>
            <OutlinedInput
              onChange={(e) => setUrlMacro(e.target.value)}
              error={Boolean(urlMacroError)}
              name="urlMacroInput"
              id="urlMacroInput"
              inputProps={{ 'data-testid': 'urlMacroInput' }}
              sx={{ borderRadius: '0 4px 4px 0' }}
              value={urlMacro}
            />
            <FormHelperText error={!!urlMacroError}>{urlMacroError || ` `}</FormHelperText>
          </FormControl>
          {/* HTML */}
          <Typography variant="body2">{previewToolConst.htmlDescription}</Typography>
          <FormControl fullWidth sx={{ my: 1 }}>
            <InputLabel htmlFor="previewHtml">HTML</InputLabel>
            <OutlinedInput
              onChange={(e) => setHtmlContent(e.target.value)}
              error={Boolean(error)}
              name="previewHtml"
              id="previewHtml"
              label="HTML"
              fullWidth
              multiline
              rows={7}
              value={htmlContent}
            />
            <FormHelperText error={!!error}>{error || ` `}</FormHelperText>
          </FormControl>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Button variant="contained" color="primary" onClick={() => handlePreview('previewpage')}>
              {previewToolConst.openInPreview} <OpenInNewIcon sx={{ ml: 1 }} fontSize="small" />
            </Button>
            <Button variant="outlined" color="primary" onClick={() => handlePreview('testatag')}>
              {previewToolConst.testATag} <OpenInNewIcon sx={{ ml: 1 }} fontSize="small" />
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default PreviewTool;
